import React, { useState, useEffect, useRef } from 'react';
import './RocketAnimation.css';
import rocketWithThruster from './rocket_thruster.svg';
import rocketWithoutThruster from './rocket.svg';
import home_popup from './home_popup.png'
import 'animate.css';

const RocketAnimation = ({ delay = 1000, popupDelay = 2000 }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showRocket, setShowRocket] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isFloating, setIsFloating] = useState(false); // Added floating state
  const rocketRef = useRef(null);

  useEffect(() => {
    const rocketTimer = setTimeout(() => {
      setShowRocket(true);
      setIsAnimating(true);

      const popupTimer = setTimeout(() => {
        setIsAnimating(false);
        setIsFloating(true); // Start floating animation
        setShowPopup(true);
      }, popupDelay);

      return () => {
        clearTimeout(popupTimer);
      };
    }, delay);

    return () => clearTimeout(rocketTimer);
  }, [delay, popupDelay]);

  const handleRocketClick = () => {
    setShowPopup(!showPopup);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="rocket-animation-container">
      {showRocket && (
        <img
          ref={rocketRef}
          src={isAnimating ? rocketWithThruster : rocketWithoutThruster}
          alt="Rocket"
          className={`rocket-image ${isFloating ? 'floating' : 'custom-rocket-animation'}`}
          onClick={handleRocketClick}
        />
      )}

      {showPopup && (
        <div className="popup animate__animated animate__fadeIn">
          <div className="popup-content">
            <img src={home_popup} alt="Click Launch button for game or use navbar to explore my portfolio" className="popup-image"/><br></br>
            <button onClick={closePopup}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RocketAnimation;